query SearchBimClasses(
    $term: String!
) {
    searchBimClasses(
        term: $term
    ) {
        id
        revisionID

        data {
            name(language: "en") {
                text
            }
        }
    }
}
